import { useCallback } from 'react';

import { useVMMutation, useVMState } from '../containers/main';
import onUpdatePresentationUrl from '../events/onUpdatePresentationUrl';
import entities from '../constants/entities';

const useOnDropPresentationUrlSlider = () => {
    const stateCtx = useVMState();
    const mutationCtx = useVMMutation();

    return useCallback(
        acceptedFiles => {
            return onUpdatePresentationUrl(
                stateCtx,
                mutationCtx,
                acceptedFiles,
                entities.virtualEventUserEntity.mode.slide,
            );
        },
        [stateCtx],
    );
};

export default useOnDropPresentationUrlSlider;
